@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex h-full w-full justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
}
<div class="chartContainer" [ngClass]="{ hide: loading() || timeOut() }">
  @if (!loading()) {
    <div class="chartValues">
      <span class="percentage">{{ percantage() }}</span>
      <span> {{ "available_gates_doughnut_chart.label" | translate }}</span>
    </div>
  }

  <canvas [id]="chartId()" class="chart"></canvas>
</div>
